<template>
  <section id="main" class="download">
    <b-container>
      <b-row>
        <b-col cols='12' class="pb-3">
          <h3 class="title pb-4 pr-4 pl-4 pr-sm-4 pl-sm-4 pr-md-0 pl-md-0 pr-lg-5 pl-lg-0">
            {{ $t('instructionsData.title') }}
          </h3>
        </b-col>
      </b-row>
      <keep-alive>
        <instruction/>
      </keep-alive>
    </b-container>
    <keep-alive>
      <other-products :otherProducts="otherProducts"/>
    </keep-alive>
    <keep-alive>
      <contact/>
    </keep-alive>
  </section>
</template>

<script>
import Instruction from "@/components/subcomponents/Instruction.vue";

export default {
  name: "Download",
  components: {Instruction},
  data() {
    return {
      position: true,
      otherProducts: 'heading.products',
    }
  }
}
</script>

<style lang="scss" scoped>
.download {
  margin-top: 124px;
  background: $background-gray-color;
  @media (max-width: 1199.98px) {
    margin-top: 70px;
  }

  h3 {
    padding: 114px 0;
    @media (max-width: 1199.98px) {
      padding-top: 70px;
    }
  }

  .products-band {
    margin-top: 124px;
    @media (max-width: 1199.98px) {
      margin-top: 70px;
    }
  }
}
</style>
